/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, range: NonNullable<unknown> }} Partner_Org_Trend_Subtitle_BillInputs */



/**
* | output |
* | --- |
* | "Daily AI usage cost for {name} ({range})." |
*
* @param {Partner_Org_Trend_Subtitle_BillInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_trend_subtitle_bill = /** @type {((inputs: Partner_Org_Trend_Subtitle_BillInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Trend_Subtitle_BillInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tägliche KI-Nutzungskosten für ${i?.name} (${i?.range}).`)
	return /** @type {LocalizedString} */ (`Daily AI usage cost for ${i?.name} (${i?.range}).`)
});